import React from "react";
import { AgentBrain, BRAINS, SHORT, brainColor } from "./AgentBrain";
import { useHouseLive, STATUS_COLOR, agoCt } from "./useHouseLive";
import { STAGES } from "./floorUtil";
import { StratBox } from "./SlideStrat";

const roleOf = (a) => (STAGES.find((s) => s.agents.includes(a)) || {}).role || "";

export const SlideAgents = () => {
  const live = Object.fromEntries(useHouseLive().map((x) => [x.agent, x]));
  return (
  <div className="grid grid-cols-2 grid-rows-5 lg:grid-cols-3 lg:grid-rows-3 gap-2 h-full" data-testid="floor-slide-agents">
    {BRAINS.map((a) => {
      const s = live[a] || {};
      return (
        <div key={a} className="relative min-h-0 rounded-xl border p-2.5 flex flex-col gap-1 overflow-hidden"
          style={{ borderColor: `${brainColor(a)}cc`, background: `${brainColor(a)}0a` }} data-testid={`floor-agent-box-${a}`}>
          <span className="absolute top-1.5 right-1.5 text-[8px] font-bold tracking-widest px-1.5 py-0.5 rounded border" style={{ color: STATUS_COLOR[s.status], borderColor: `${STATUS_COLOR[s.status] || "#00F0FF"}88` }} data-testid={`floor-agent-status-${a}`}>{s.status || ""}</span>
          <div className="flex items-center gap-2 min-w-0">
            <AgentBrain agent={a} size={34} active />
            <div className="min-w-0">
              <p className="nx-orbitron text-xs font-bold truncate" style={{ color: brainColor(a) }}>{SHORT[a]}</p>
              <p className="fc-num text-[9px] text-cyan-300/50 truncate">{roleOf(a)}</p>
            </div>
          </div>
          <p className="fc-num text-[10px] text-cyan-50/85 leading-tight line-clamp-2" data-testid={`floor-agent-task-${a}`}>{s.task}</p>
          <p className="fc-num text-[9px] text-cyan-300/50 mt-auto" data-testid={`floor-agent-ago-${a}`}>started {agoCt(s.started_at)}</p>
        </div>
      );
    })}
    <StratBox />
  </div>
  );
};
